export const removeDuplicateEntries = (input1, input2) => {
  const uniqueDigits = Array.from(new Set(input2));
  const result = uniqueDigits.filter((digit) => digit !== input1);
  return result.length > 0 ? result[0] : input1;
};
